import { useOkapiKy } from "@folio/stripes/core";
import { fetchTitleSearchById } from "../api/titleService";
import { useDetailEntity } from "./useDetailEntity";
export var useRequestableTitleActions = function () {
    var kyInstance = useOkapiKy();
    var _a = useDetailEntity("requestable-title-detail", function (id) {
        return fetchTitleSearchById(kyInstance, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedTitle: selectedItem,
        handleSelectTitle: function (title) { return handleRowClick(title.id); },
        handleCloseSelectedTitle: handleCloseDetail,
    };
};
